// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell{
    box-sizing:border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.loading{
    text-align: center;
}

.tux-wizard-container {
    display: flex;
}

.tux-wizard-progress-tracker {
    flex-basis: 25%;
    padding: 20px;
}

.tux-wizard-content {
    flex-basis: 75%;
    padding: 20px;
}

.tux-margin-bottom {
    margin-bottom: 20px;
}

.tux-flex {
    display: flex;
    justify-content: flex-end;
}

.tux-justify-between {
    display: flex;
    justify-content: flex-end;
    gap: 10px; /* Adjust the value as needed */
}

.tux-margin-top {
    margin-top: 20px;
}

.tux-wizard-container {
    display: flex;
    height: 90vh; /* 90% of the viewport height */
    max-height: 90vh; /* Ensure the container doesn't exceed 90% of the viewport height */
}

.tux-wizard-progress-tracker {
    flex: 0 0 200px; /* Adjust width as needed */
    padding: 16px;
    overflow-y: auto; /* Make progress tracker scrollable if needed */
}

.tux-wizard-content-container {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    padding: 16px;
    overflow: hidden; /* Hide overflow by default */
}

.tux-wizard-content {
    flex: 1 1;
    overflow-y: auto; /* Make content area scrollable */
}

.tux-wizard-buttons {
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    padding-bottom: 16px; /* Add bottom padding to ensure buttons are not too close to the bottom */
    margin-top: auto; /* Push the buttons to the bottom of the container */
}`, "",{"version":3,"sources":["webpack://./src/components/tux_core/styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAE,+BAA+B;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY,EAAE,+BAA+B;IAC7C,gBAAgB,EAAE,mEAAmE;AACzF;;AAEA;IACI,eAAe,EAAE,2BAA2B;IAC5C,aAAa;IACb,gBAAgB,EAAE,+CAA+C;AACrE;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB,EAAE,6BAA6B;AACnD;;AAEA;IACI,SAAO;IACP,gBAAgB,EAAE,iCAAiC;AACvD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB,EAAE,yEAAyE;IAC/F,gBAAgB,EAAE,oDAAoD;AAC1E","sourcesContent":[".cell{\n    box-sizing:border-box;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.loading{\n    text-align: center;\n}\n\n.tux-wizard-container {\n    display: flex;\n}\n\n.tux-wizard-progress-tracker {\n    flex-basis: 25%;\n    padding: 20px;\n}\n\n.tux-wizard-content {\n    flex-basis: 75%;\n    padding: 20px;\n}\n\n.tux-margin-bottom {\n    margin-bottom: 20px;\n}\n\n.tux-flex {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.tux-justify-between {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px; /* Adjust the value as needed */\n}\n\n.tux-margin-top {\n    margin-top: 20px;\n}\n\n.tux-wizard-container {\n    display: flex;\n    height: 90vh; /* 90% of the viewport height */\n    max-height: 90vh; /* Ensure the container doesn't exceed 90% of the viewport height */\n}\n\n.tux-wizard-progress-tracker {\n    flex: 0 0 200px; /* Adjust width as needed */\n    padding: 16px;\n    overflow-y: auto; /* Make progress tracker scrollable if needed */\n}\n\n.tux-wizard-content-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    overflow: hidden; /* Hide overflow by default */\n}\n\n.tux-wizard-content {\n    flex: 1;\n    overflow-y: auto; /* Make content area scrollable */\n}\n\n.tux-wizard-buttons {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 16px;\n    padding-bottom: 16px; /* Add bottom padding to ensure buttons are not too close to the bottom */\n    margin-top: auto; /* Push the buttons to the bottom of the container */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
